import React from "react";

const NotFoundLayout = (props) => {
  const { icon, heading, para } = props;

  return (
    <div className="d-flex flex-column align-items-center justify-content-center h-100">
      {icon}
      <h5 className="mt-32 mb-2">{heading}</h5>
      <p className="text-sm-400 greyStrokeColor">
        {para}
      </p>
    </div>
  );
};

export default NotFoundLayout;
